import MDataTableServices from './index.vue';

MDataTableServices.install = app => {
  app.component(MDataTableServices.name, MDataTableServices);
};

export default MDataTableServices;
